import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  x: "3",
  y: "3",
  width: "18",
  height: "18",
  stroke: "currentColor",
  "stroke-width": "2"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M9 11.5C10.3807 11.5 11.5 10.3807 11.5 9C11.5 7.6193 10.3807 6.5 9 6.5C7.6193 6.5 6.5 7.6193 6.5 9C6.5 10.3807 7.6193 11.5 9 11.5Z",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M21 18L15.5 13L10.5 17.5L7 14.5L3 17.5",
  stroke: "currentColor",
  "stroke-width": "2"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }